import styled from '@emotion/styled'

export const CancelLink = styled.a`
  color: rgba(0, 122, 255, 0.87);
  cursor: pointer;
  font-size: 16px;
`
